module.exports = __webpack_public_path__ + "static/media/dj_jessi.87fb18ea.jpg";